// export const downloadImage = (name, img) => {
//     fetch(img)
//         .then(response => response.blob())
//         .then(blob => {
//             const url = window.URL.createObjectURL(new Blob([blob]));
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', name + ".jpg");
//             document.body.appendChild(link);
//             link.click();
//             link.parentNode.removeChild(link);
//         })
//         .catch(error => {
//             console.error('Error downloading image:', error);
//         });
// };

export const downloadImage = (name, img) => {
  fetch(img, { mode: 'cors' })
    .then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.blob();
    })
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${name}.jpg`;
      a.click();
      window.URL.revokeObjectURL(url);
    })
    .catch(err => console.error("Error:", err));
};









